module.exports = __webpack_public_path__ + "img/notes.aca57cd6.svg";